var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 207,
    viewBox: "0 0 155 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_4475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.097 92.4723L145.69 92.25C148.731 92.25 151.157 94.764 151.037 97.791L147.552 193.766C147.449 196.639 145.092 198.914 142.222 198.914L9.34512 199.273C6.47507 199.273 4.11752 197.016 3.99794 194.142L0.000361226 98.2185C-0.119224 95.1915 2.28957 92.6604 5.33046 92.6433C7.73926 92.6433 63.6882 92.4894 66.097 92.4723Z",
    fill: "#01EB11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0002 45.8984L9.07129 62.7437L34.338 175.359L118.919 156.342L95.7367 52.9786L84.0002 45.8984Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4951 84.1344L85.247 71.3594",
    stroke: "#ACACAC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0752 95.6813L87.8271 82.9062",
    stroke: "#ACACAC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6719 107.203L90.4238 94.4453",
    stroke: "#CECECE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.251 118.75L93.02 105.992",
    stroke: "#CECECE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8477 130.289L95.5996 117.531",
    stroke: "#CECECE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4443 141.836L98.1962 129.078",
    stroke: "#CECECE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0244 153.383L100.776 140.625",
    stroke: "#CECECE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5059 49.8125L83.8463 60.2788L94.0453 57.9872",
    stroke: "#CECECE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.45 10.4353L69.24 0.960938L55.0264 115.492L141.06 126.18L154.112 21.0555L145.45 10.4353Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.293 27.6562L138.019 34.8219",
    stroke: "#ACACAC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8408 39.3906L136.566 46.5734",
    stroke: "#ACACAC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3887 51.1406L135.114 58.3063",
    stroke: "#ACACAC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9365 62.8672L133.662 70.0499",
    stroke: "#ACACAC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4678 74.6172L132.193 81.7828",
    stroke: "#ACACAC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0156 86.3516L130.741 93.5343",
    stroke: "#ACACAC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5635 98.0781L129.289 105.261",
    stroke: "#CECECE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.76 13.2734L140.444 23.9107L150.831 25.2105",
    stroke: "#CECECE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.547 96.0272L138.497 88.5195C137.865 86.1936 135.747 84.569 133.321 84.5861L97.24 84.6887C94.8312 84.6887 92.7129 86.3134 92.0979 88.6563L90.082 96.1811C89.4499 98.524 87.3486 100.149 84.9398 100.149L5.34706 100.371C2.30617 100.371 -0.102623 102.902 0.0169628 105.946L4.03162 201.887C4.15121 204.76 6.50875 207.018 9.37881 207.018L142.255 206.642C145.126 206.642 147.483 204.35 147.586 201.494L151.071 105.519C151.173 102.492 148.747 99.9606 145.723 99.9777C143.315 99.9777 141.196 98.3701 140.547 96.0443V96.0272Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.9 182.838L82.5116 182.976C80.9077 182.981 79.6111 184.286 79.6155 185.892L79.6354 193.006C79.6399 194.612 80.9437 195.91 82.5477 195.905L131.936 195.767C133.54 195.763 134.837 194.457 134.832 192.852L134.813 185.737C134.808 184.132 133.504 182.834 131.9 182.838Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_4475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 207,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/board.beef50180f8e28e3b1942685fad8bfc6.svg";
export { ForwardRef as ReactComponent };